import { faAngleDown, faBellConcierge, faMoneyBillWave, faUser } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';
import { useAbandonedBookings } from 'components/Bookings2/Abandoned/AbandonedBookingsProvider';
import styles from 'components/Bookings2/Abandoned/Header/Actions/AddButton/AbandonedBookingsAddButton.module.scss';
import { Dropdown } from 'components/UI/V2/Dropdown/Dropdown';
import { SelectDropdownItem } from 'components/UI/V2/SelectDropdown/Item/SelectDropdownItem';
import { useMarketplace } from 'hooks';
import React from 'react';
import { ClientsPath, PaymentsPath } from 'routes/Paths';
import { isPaymentsEnabled } from 'utils/MarketingUtils';

interface AbandonedBookingsAddButtonProps {
    className?: string;
}

export const AbandonedBookingsAddButton: React.FC<AbandonedBookingsAddButtonProps> = props => {
    const marketplace = useMarketplace();
    const { setShowCreateBooking } = useAbandonedBookings();
    const paymentsEnabled = isPaymentsEnabled(marketplace);

    return (
        <Dropdown
            label="Add"
            buttonProps={{
                size: 'large',
                variant: 'primary',
                rightIcon: faAngleDown,
                className: clsx(styles.button, props.className)
            }}
        >
            <SelectDropdownItem
                label="Appointment"
                leftIcon={faBellConcierge}
                onClick={() => setShowCreateBooking(true)}
            />

            <SelectDropdownItem
                label="Client"
                leftIcon={faUser}
                href={`${ClientsPath}#create`}
            />

            {paymentsEnabled && (
                <SelectDropdownItem
                    label="Single Sale"
                    leftIcon={faMoneyBillWave}
                    href={`${PaymentsPath}#SINGLE_SALE`}
                />
            )}
        </Dropdown>
    );
};
